import { useQuery } from '@powersync/react';

import { createBlock } from '@flow/domain';
import { applyLocalOperations, queries, type WorkspaceSummary } from '@flow/sync';

import type { LocalDatabase } from './powersync.js';
import { useNextSortKey } from './use-next-sort-key.js';

/**
 * Creating a block in the user's Personal workspace (capture stage, at the end of the list)
 * through the domain command and the local executor: no SQL in the UI (CLAUDE.md). Must be
 * used inside a `PowerSyncContext.Provider`.
 */
export function useCreateBlock(local: LocalDatabase, userId: string) {
  const workspaceQuery = queries.personalWorkspace();
  const { data: workspaces } = useQuery<WorkspaceSummary>(
    workspaceQuery.sql,
    workspaceQuery.params,
  );
  const workspaceId = workspaces[0]?.id ?? '';
  const stageQuery = queries.captureStage(workspaceId);
  const { data: stages } = useQuery<{ id: string }>(stageQuery.sql, stageQuery.params);
  const nextSortKey = useNextSortKey(workspaceId);

  return {
    ready: workspaceId !== '',
    create: (title: string) =>
      applyLocalOperations(
        local.db,
        createBlock({
          workspace_id: workspaceId,
          created_by: userId,
          title,
          stage_id: stages[0]?.id ?? null,
          sort_key: nextSortKey(),
        }),
      ),
  };
}
